import { render } from "./RelacionUsuarioPerfil.vue?vue&type=template&id=0a34618e"
import script from "./RelacionUsuarioPerfil.vue?vue&type=script&lang=js"
export * from "./RelacionUsuarioPerfil.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__